import create from '../creator'
import axios from '../../axios-setup'

const initialState = () => ({
	productDetails: {
		id: '',
		name: '',
		price: '',
		promotedPrice: null,
		description: null,
		position: null,
		new: false,
		trending: false,
		favorite: false,
		favoritePosition: null,
		gallery: [],
		acceptProductNote: null,
		orderType: 1,
		ingredients: [
			{
				portionSize: null,
				brandName: '',
				foodTypeName: null,
				ingredientTypeName: '',
				retailBrandName: null,
				classificationName: ''
			}
		]
	},
	productModifiers: {
		id: '',
		name: '',
		classId: null,
		forcedModCategories: []
	},
	isProductDetailsLoading: false,
	isProductModifiersLoading: false
})
const state = initialState()

const actions = {
	async getProductDetails({ commit }, productId) {
		try {
			const resp = await axios.get(
				`product/${productId}`,
				{},
				{ skipError: true }
			)

			commit('getProductDetailsSuccess', resp.data)

			return resp.data
		} catch (e) {
			commit('getProductDetailsError')
			throw e
		}
	},

	async getProductModifiers({ commit }, productId) {
		commit('getProductModifiers')

		try {
			const resp = await axios.get(
				`product/${productId}/modifiers`,
				{},
				{ skipError: true }
			)

			commit('getProductModifiersSuccess', resp.data)

			return resp.data
		} catch (e) {
			commit('getProductModifiersError')
			throw e
		}
	},

	clearProductDetails({ commit }) {
		commit('clearProductDetails')
	},

	clearProductModifiers({ commit }) {
		commit('clearProductModifiers')
	}
}

const mutations = {
	getProductDetails(state) {
		state.isProductDetailsLoading = true
	},

	getProductDetailsError(state) {
		state.isProductDetailsLoading = false
	},

	getProductDetailsSuccess(state, payload) {
		state.isProductDetailsLoading = false
		state.productDetails = payload
	},

	getProductModifiers(state) {
		state.isProductModifiersLoading = true
	},

	getProductModifiersError(state) {
		state.isProductModifiersLoading = false
	},

	getProductModifiersSuccess(state, payload) {
		state.isProductModifiersLoading = false
		state.productModifiers = payload
	},

	clearProductDetails() {
		state.productDetails = initialState().productDetails
	},

	clearProductModifiers() {
		state.productModifiers = initialState().productModifiers
	}
}

export default create(
	{
		namespaced: true,
		state,
		actions,
		mutations
	},
	initialState()
)
